import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '@mui/material';
import React from 'react'

function Popup(props) {

    const { title, children, openPopup, setOpenPopup,note } = props;


    return (
        <Dialog open={openPopup} maxWidth="xl" fullWidth>
            <DialogTitle>
                <div style={{ display: 'flex' }}>
                    <Typography variant="h6" component="div" style={{ flexGrow: 1 }}>
                        {title}
                    </Typography>
                    <Button
                        variant="text"
                        color="secondary"
                        onClick={()=>{setOpenPopup(false)}}>
                        <CloseIcon />
                    </Button>
                </div>
            </DialogTitle>
            <DialogContent dividers>
                {children}
            </DialogContent>
            <div style={{paddingLeft:"25px"}}>
                {note}
            </div>            
        </Dialog>
    )
}

export default Popup
